import { useMeteoTrackerController } from "@geoflow/benchmap"
import { useGeoFlowSession } from "../../../hooks/useGeoFlowSession.jsx"
import environments from "../../../config/environment.js"

const EMPTY_SCENE_DEFINITIONS = []
// Ice-Overlay hat keine UI mehr und bleibt dauerhaft an
const INITIAL_SELECTOR_STATE = { ice: "on" }

// Einzige Naht zwischen App und Wetter-Feature — benchmaps Controller-Form bleibt hier gekapselt
export function useWeatherLayers() {
  const geoflowSession = useGeoFlowSession()

  const rawController = useMeteoTrackerController({
    geoserverUrl: geoflowSession.geoserverUrl,
    geoflowApiUrl: geoflowSession.geoflowApiUrl,
    charter: environments.geoflow.charter,
    initialWeatherVisible: false,
    initialSelectorState: INITIAL_SELECTOR_STATE,
    enabled: Boolean(geoflowSession.geoflowBase),
  })

  // Ohne Definitionen ersetzt der Preset sonst die GANZE App durch seinen Loading-/Error-Text
  const controller = rawController.sceneDefinitions
    ? rawController
    : { ...rawController, sceneDefinitions: EMPTY_SCENE_DEFINITIONS }

  const hasWeatherTimeSlider =
    controller.weatherVisible && controller.time.state.hasTimes

  // Slider-Rechtskante = letzter selektierbarer Step: state.timestamps enthält auch
  // Cluster-Ausreißer, die die Timeline verwirft und die Karte nie anzeigen kann
  const steps = controller.time.state.steps
  let weatherMaxTimestamp = null
  for (let i = steps.length - 1; i >= 0; i--) {
    if (steps[i].selectable) {
      weatherMaxTimestamp = steps[i].sourceTimestamp ?? steps[i].iso
      break
    }
  }

  return {
    controller,
    geoflowSession,
    hasWeatherTimeSlider,
    weatherMaxTimestamp,
  }
}
